export default "__VITE_ASSET__BnuMIWaN__"